import React from 'react'
import { FormControlLabel, FormGroup, Switch, SwitchProps } from '@material-ui/core'
import { useSwitchStyles } from './styles'

interface StyledSwitchProps extends Omit<SwitchProps, 'classes'> {
  isCompleteAnimalRegistration: boolean
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const StyledSwitchComponent: React.FC<StyledSwitchProps> = ({ isCompleteAnimalRegistration, handleChange }) => {
  const styles = useSwitchStyles()

  return (
    <FormGroup row className={styles.formGroupContainer}>
      <FormControlLabel
        className={styles.container}
        control={
          <Switch
            checked={isCompleteAnimalRegistration}
            onChange={handleChange}
            name='isCompleteAnimalRegistration'
            color='primary'
            classes={{
              root: styles.root,
              switchBase: styles.switchBase,
              thumb: styles.thumb,
              track: styles.track,
              checked: styles.checked,
            }}
          />
        }
        label='Cadastro completo'
        labelPlacement='bottom'
      />
    </FormGroup>
  )
}

export const AnimalRegistrationSwitch = StyledSwitchComponent
